import angular from 'angular';
import moment from 'moment';

import templateUrl from './lead-activities-report.component.html';

export const LeadActivitiesReportComponent = {
    controller: LeadsActivitiesReportController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
    }
};

function LeadsActivitiesReportController($q, apexApiUrl, utilityService, leadBatchService,
    leadsService, icdCorporationService, divisionService, employeeService) {
    'ngInject';
    const vm = this;

    vm.$onInit = onInit;
    vm.filters = {};
    vm.onExport = onExport;
    vm.onRefreshData = onRefreshData;
    vm.onChangeFilter = onChangeFilter;
    vm.showFilters = true;
    vm.reportHeaders;
    vm.filteredReport;
    vm.report;
    vm.loaded = false;
    vm.statusTotals = [];
    vm.pageSize = 10;
    vm.pageNumber = 1;
    vm.getReportCellValue = getReportCellValue;
    vm.onChangeIcdCorporation = onChangeIcdCorporation;
    vm.filters.StartDate = moment().subtract(1, "week").startOf("day").toDate();
    vm.filters.EndDate = moment().startOf("day").toDate();

    function onInit() {
        $q.when(utilityService.showLoading())
            .then(loadIcdCorporations)
            .then(function () {
                vm.loaded = true;
            })
            .catch(function (ex) {
                $.winxnetAlertWindow({ message: "Initial load failed: " + utilityService.getExceptionMessage(ex) });
            })
            .then(utilityService.hideLoading);
    }

    function loadIcdCorporations() {

        const geticdCorporations = icdCorporationService.retrieveIcdCorporationsByModuleAdmin("Payout", {
            divisionID: divisionService.divisionIDs.Rogers
        })
        return geticdCorporations
            .then(function (corporations) {
                vm.icdCorporations = corporations;
                vm.icdCorporations = vm.icdCorporations.sort(function (a, b) {
                    if (a.Owner < b.Owner) {
                        return -1;
                    } else if (a.Owner > b.Owner) {
                        return 1;
                    }
                    return a.ClientName < b.ClientName ? -1 : 1;
                });
                vm.icdCorporations.forEach(formatIcdCorporation);

            });
    }

    function mapLeadGroupToMapCodes(leadGroup) {
        return leadGroup.Name.replace("Map Area Code: ", "");
    }

    function formatIcdCorporation(icdCorporation) {
        icdCorporation.OwnerClientName = icdCorporation.Owner + " - " + icdCorporation.ClientName;
    }

    function retrieveLeadGroups() {
        const leadGroupRequest = {
            IcdCorporations: vm.filters.Corporations ? vm.filters.Corporations.map(function (corporation) {
                return corporation.Id
            }) : null,
            ContainsDate: null,
            IcdOffices: null,
        }
        return leadBatchService.retrieveLeadGroups(leadGroupRequest).then(function (leadGroups) {
            vm.leadGroups = leadGroups;
            vm.mapCodes = vm.leadGroups.map(mapLeadGroupToMapCodes).filter(function (value, index, self) {
                return self.indexOf(value) === index
            }).sort(function (a, b) {
                return a < b ? -1 : 1;
            });
        });
    }

    function onChangeIcdCorporation() {
        vm.filters.Employee = null;
        if (vm.filters.Corporations) {
            if (vm.filters.Corporations.length > 0) {
                utilityService.showLoading();
                const requests = retrieveIcdEmployees();
                $q.all(requests).then(function (v) {
                    vm.employees = Array.prototype.concat.apply([], v);
                }).then(retrieveLeadGroups)
                    .then(function () {
                        utilityService.hideLoading();
                    }).catch(function (ex) {
                        utilityService.hideLoading();
                        alert(ex);
                    });
            } else {
                vm.employees = [];
                vm.mapCodes = [];
            }
        }
    }

    function retrieveIcdEmployees() {
        return vm.filters.Corporations.map(function (corporation) {
            return employeeService.retrieveEmployees({ IcdCorporationID: corporation.Id })
                .then(function (employees) {
                    return employees.map(function (entity) {
                        return {
                            EmployeeName: entity.FirstName + " " + entity.LastName,
                            EmployeeID: entity.Id
                        }
                    });
                });
        });
    }

    function getReportHeaders(report) {

        const allStatuses = report.map(function (p) {
            return p.LeadStatusCounts;
        })
            .reduce(function (a, b) {
                return a.concat(b);
            }, []);

        const distinctStatuses = allStatuses.filter(function (status) {
            if (!this[status.LeadStatus]) {
                this[status.LeadStatus] = true;
                return true;
            }
            return false;
        }, Object.create(null));

        return distinctStatuses
            .sort(function (a, b) {
                return a.SortIndex - b.SortIndex;
            });
    }

    function getReportCellValue(leadStatusCounts, leadStatus) {
        const cellValue = leadStatusCounts.filter(function (statusCount) {
            return statusCount.LeadStatus === leadStatus
        })[0];
        return cellValue ? cellValue.Count : "-";
    }

    function onRefreshData() {
        vm.loaded = false;
        $q.when(utilityService.showLoading())
            .then(loadActivityReport)
            .then(function (result) {
                vm.reportHeaders = getReportHeaders(result);
                vm.report = result;
                vm.filteredReport = angular.copy(vm.report);
                calculateTotals();
                vm.loaded = true;

            })
            .catch(function (ex) {
                $.winxnetAlertWindow({ message: "Initial load failed: " + utilityService.getExceptionMessage(ex) });
            })
            .then(utilityService.hideLoading);
    }

    function loadActivityReport() {
        return leadsService.retrieveLeadsActivityReport(createLeadActivityReportQuery());
    }

    function onExport() {

        const queryString = utilityService.queryStringify(createLeadActivityReportQuery());
        window.location = apexApiUrl + "reports/rogers/lead-group-rep-statistics.xlsx" + queryString;
    }

    function createLeadActivityReportQuery() {
        const query = {
            IcdCorporationID: vm.filters.Corporations ? vm.filters.Corporations.map(function (corporation) {
                return corporation.Id
            }) : null,
            EmployeeID: vm.filters.Employee ? vm.filters.Employee.EmployeeID : null,
            StartDate: vm.filters.StartDate ? moment(vm.filters.StartDate).format("YYYY-MM-DD") : null,
            EndDate: vm.filters.EndDate ? moment(vm.filters.EndDate).format("YYYY-MM-DD") : null,
            MapAreaCode: vm.filters.MapCode ? vm.filters.MapCode === "All" ? null : vm.filters.MapCode : null,
        };
        return query;
    }

    function calculateTotals() {

        vm.statusTotals = [];

        vm.doorKnockedTotal = vm.filteredReport.reduce(function (columnTotals, report) {
            columnTotals += report.DoorsKnocked
            return columnTotals;
        }, 0);

        vm.reportHeaders.forEach(function (header) {
            const columnTotals = vm.filteredReport.reduce(function (columnTotals, report) {
                const statusCount = report.LeadStatusCounts.filter(function (statusCount) {
                    return statusCount.LeadStatus === header.LeadStatus
                })[0];
                columnTotals.total += statusCount ? statusCount.Count : 0
                return columnTotals;
            }, { total: 0 });
            vm.statusTotals.push({ header: header, total: columnTotals.total });
        });

    }

    function onChangeFilter() {
        vm.filteredReport = angular.copy(vm.report);
        vm.filteredReport = vm.filteredReport.filter(filterLeadActivityReport);
        calculateTotals();
    }

    function filterLeadActivityReport(data) {
        const fullName = data.Employee.FirstName + " " + data.Employee.LastName;
        return (!vm.filters.ClientName || utilityService.containsInvariant(data.ClientName, vm.filters.ClientName))
            && (!vm.filters.OfficeName || utilityService.containsInvariant(data.OfficeName, vm.filters.OfficeName))
            && (!vm.filters.MapAreaCode || utilityService.containsInvariant(data.MapAreaCode, vm.filters.MapAreaCode))
            && (!vm.filters.EmployeeName || utilityService.containsInvariant(fullName, vm.filters.EmployeeName))
            && (!vm.filters.Owner || utilityService.containsInvariant(data.Owner, vm.filters.Owner))
        ;
    }

}
